import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from '../global-service/global-service';

@Injectable()
export class ContactServiceProvider {
  baseUrl: String = this.globalServiceProvider.appConfig.BaseApiUrl;
  constructor(
    public http: Http,
    public globalServiceProvider: GlobalServiceProvider
  ) {
    console.log('Hello ContactServiceProvider Provider');
  }
  getContact() {
    let uri = this.baseUrl + '/api/depots/contacts';
    let result = null;
    return this.http
      .get(uri)
      .toPromise()
      .then(data => {result = data.json();
        return result;
      })
      .catch(
        err => {
          console.log('err: ', err);
          return null;
        }
      );
  }

  lookupsResource(filter, condition){
    return this.http
      .get(this.globalServiceProvider.appConfig.BaseApiTmsUrl + "/contact/",  { params: { filter: filter, condition: condition } })
      .toPromise()
      .then(data => {
        let result = data.json();
        return result;
      }
      )
      .catch(
      err => {
        return null;
      }
      );
  }

  private contactData: any = null;
  get getContactData(): any {
    return this.contactData;
  }
  set setContactData(valueObj: any) {
    this.contactData = valueObj;
  }
}



// WEBPACK FOOTER //
// ./src/providers/contact-service/contact-service.ts